export default __webpack_public_path__ + "static/media/step7.96fa8803.png";